export enum TreatmentPlanScope {
  summary = 'Treatment Plan',
  full = 'Full Chart',
}
